import { Mail } from 'lucide-react';
import Seo from './Seo';

const AboutPage = () => {

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <Seo
        title="About Uumail - Private Email Alias Service"
        description="Learn about Uumail, a stable email alias service from BitRabbit that has been running for more than 10 years."
        path="/about"
      />
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8">
          <div className="flex items-center justify-center mb-8">
            <Mail className="h-12 w-12 text-blue-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">About Us</h1>

          <div className="space-y-8 text-gray-700">
            <p>
              BitRabbit PTE. LTD. is a Singapore-based technology company dedicated to building innovative and user-centric internet tools that empower individuals to manage their digital lives with ease and privacy.
            </p>

            <p>
              We are the creators of UUMail, a smart email alias and privacy protection service designed to help users stay in control of their online identities. With UUMail, users can create multiple private email addresses to sign up for online services, manage unwanted messages, and protect their real inbox from spam and breaches - all without compromising usability.
            </p>

            <p>
              UUMail has been running for more than 10 years, giving the service a long operational history and a stable foundation for everyday email alias forwarding.
            </p>

            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Values</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Simplicity:</strong> Technology should be intuitive and easy to use.</li>
                <li><strong>Privacy-first design:</strong> Your data belongs to you. We will never sell or share your personal information.</li>
                <li><strong>Transparency:</strong> We are committed to building trust through honest communication and clear policies.</li>
                <li><strong>Continuous improvement:</strong> We actively iterate and evolve our products based on user feedback and emerging needs.</li>
              </ul>
            </div>

            <p>
              With over 20 years of experience in the browser and internet tool space, our team combines deep industry expertise with a passion for crafting digital products that truly make a difference.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Company Information</h2>
              <div className="space-y-2">
                <p>BitRabbit PTE. LTD.</p>
                <p>Registered in Singapore</p>
                <p>Website: <a href="https://bitrabbit.sg" className="text-blue-600 hover:text-blue-700">bitrabbit.sg</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
